import { render, staticRenderFns } from "./RslevCpuidSetdiopter.vue?vue&type=template&id=2f46a32c&scoped=true&"
import script from "./RslevCpuidSetdiopter.vue?vue&type=script&lang=js&"
export * from "./RslevCpuidSetdiopter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46a32c",
  null
  
)

export default component.exports